import React, { useState,useEffect } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import searchicon from '../../assets/images/admin/navbar/searchicon.svg';
import notiifcationicon from '../../assets/images/admin/navbar/notifcation.svg';
import userimg from '../../assets/images/admin/navbar/user.png';
import dropdown from '../../assets/images/admin/navbar/dropdown.svg';
import shoppingcarticon from '../../assets/images/admin/sidebar/ShoppingCart.svg';
import { Link } from "react-router-dom";
// import { Drawer, ButtonToolbar, Button, Placeholder } from 'rsuite';
// import 'rsuite/dist/rsuite.min.css';  
import Navback from '../../assets/images/admin/navbar/NavBack.svg';
import Navhome from '../../assets/images/admin/navbar/Navhome.svg';
import { useNavigate } from "react-router-dom";
import notificationrowicon from '../../assets/images/admin/navbar/notificationrowicon.svg';
import sidebar_user from '../../assets/images/admin/sidebar/sidebar_user.svg';
import sidebar_signout from '../../assets/images/admin/sidebar/sidebar_signout.svg';
import sidebar_user1 from '../../assets/images/admin/sidebar/sidebar_users1.svg';
import sidebar_signout1 from '../../assets/images/admin/sidebar/sidebar_signout1.svg';
import { apiUrl } from "../../config/Config";
import axios from "axios";
import { useDispatch, useSelector } from 'react-redux';

const Navbar = (props) => {
    const [shownavdropdown, setshownavdropdown] = useState(false);
    const [sticky, setSticky] = useState("");
    const [open, setOpen] = useState(false);
    const [activenotification, setactivenotification] = useState("all");
    const [showloding, setshowloding] = useState(false);

    const userdata = useSelector((store) => store.userReducer.userdata);


    let navigate = useNavigate();
    const dispatch = useDispatch();

    const handlehomenavigate = () => {
      setOpen(false);
      navigate('/dashbaord');
    }

    // console.log('userdata >>', userdata);

    const handlelogout = async() => {
      // console.log('handlelogout');
      // dispatch({ type: "userdata", payload: {} })
      var data = {
        
    }
    const headers = {
      headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer " + userdata?.token,
      }
  }
    let resp = await axios.post(apiUrl + 'adminlogout', data, headers).then((res) => {
        if(res.data.status == 'success') {
          dispatch({ type: "userdata", payload: {} })
        navigate('/admin/login');
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} })
            navigate('/admin/login');
          } else {
            alert(res.data.message);
          }
          
        }
    } ).catch((err) => {
        alert(err.message)
    })
    setshowloding(false);
      
    }

    useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
          //   fetchdata();
          // fetchallcourses();
        } else {
          navigate("/admin/login");
        }
      }, []);


    return (
      <>
        <div className="navbarmaindiv">
          <div className="navbarrow">
            <p className="nav-pagetitle">{props.title}</p>
            {/* <div className="nav-searchdiv">
              <input
                type="text"
                className="form-control nav-searchinput"
                placeholder="Search here..."
              />
              <img src={searchicon} className="nav-searchicon" />
            </div> */}
            <div
              className="notificationbg"
              style={{ cursor: "pointer", marginLeft: 'auto' }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <img src={notiifcationicon} className="nav-notifyicon" />
            </div>
            <div
              className="nav-profilediv"
              onClick={() => {
                setshownavdropdown(!shownavdropdown);
              }}
            >
              <img src={userimg} className="nav-userimg" />
              <div className="nav-profilenamediv">
                <p className="nav-profilename">{userdata?.firstname} {userdata?.lastname}</p>
                <p className="nav-profiledesig">{userdata?.type}</p>
              </div>
              <div className="nav-profiledowndiv">
                <img src={dropdown} className="nav-profiledownicon" />
              </div>
              {shownavdropdown ? (
                <div className="dropdown-content" style={{ display: "block" }}>
                  {/* <div
                    onClick={() => {navigate('/admin/profile')}}
                    className={"sidebarnavrow navbardropdownicon atag"}
                  >
                    <div className="navbarnavicon" />
                    <p className="shoppingtext">Profile</p>
                  </div> */}
                  <div
                    onClick={() => {handlelogout()}}
                    className={"sidebarnavrow navbardropdownicon atag"}
                  >
                    {/* <img src={sidebar_signout} className="sidebarnavicon" /> */}
                    <div className="navbarnavicon navbarnavicon1" />
                    <p className="shoppingtext">Sign Out</p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {/* Notifications Drawer */}
        {/* <Drawer
          open={open}
          placement="right"
          onClick={() => setOpen(false)}
          onClose={() => setOpen(false)}
          backdrop={true}
          size={"xs"}
          className="notificationsidebar"
        >
          <Drawer.Body>
            <div className="navbar-sidebar-topdiv">
              <div className="navbar-sidebar-headerrow">
                <div
                  className="navbar-sidebar-header-left"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <img src={Navback} />
                </div>
                <p className="navbar-sidebar-header-notificationtext">
                  Notification
                </p>
                <div
                  className="navbar-sidebar-header-left-rightdiv"
                  onClick={() => {
                    handlehomenavigate();
                  }}
                >
                  <img src={Navhome} />
                </div>
              </div>
            </div>
            <div className="navbar-sidebar-tabrow d-flex">
              <div
                className="navbar-sidebar-tabdiv"
                onClick={() => {
                  setactivenotification("all");
                }}
              >
                <p
                  className="navbar-sidebar-tabname"
                  style={activenotification == "all" ? {} : { borderBottom: 0 }}
                >
                  All
                </p>
              </div>
              <div
                className="navbar-sidebar-tabdiv"
                onClick={() => {
                  setactivenotification("unread");
                }}
              >
                <p
                  className="navbar-sidebar-tabname"
                  style={
                    activenotification == "unread" ? {} : { borderBottom: 0 }
                  }
                >
                  Unread
                </p>
                <div className="navbar-sidebar-unreaddiv">
                  <p>12</p>
                </div>
              </div>
            </div>

            <div className="navbar-sidebar-tabbody">
              <div className="notification-row">
                <div className="notification-rowimgdiv">
                  <img
                    src={notificationrowicon}
                    className="notification-rowimg"
                  />
                  <div className="newnotiifcationcircle"></div>
                </div>
                <div className="notification-rowtextdiv">
                  <p className="notification-rowtitle">SALE IS LIVE</p>
                  <p className="notification-rowdesc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    dolor sit amet, consectetur adipiscing elit.
                  </p>
                </div>
                <div className="notification-rowdatediv">
                  <p className="notification-rowdate">1m ago</p>
                </div>
              </div>
              <div className="notification-row">
                <div className="notification-rowimgdiv">
                  <img
                    src={notificationrowicon}
                    className="notification-rowimg"
                  />
                  <div className="newnotiifcationcircle"></div>
                </div>
                <div className="notification-rowtextdiv">
                  <p className="notification-rowtitle">SALE IS LIVE</p>
                  <p className="notification-rowdesc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    dolor sit amet, consectetur adipiscing elit.
                  </p>
                </div>
                <div className="notification-rowdatediv">
                  <p className="notification-rowdate">1m ago</p>
                </div>
              </div>
            </div>
          </Drawer.Body>
        </Drawer> */}
      </>
    );
}

export default Navbar